import { ExternalLinkIcon, SparklesIcon } from "@heroicons/react/outline";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { OAuthError, postData } from "../backend";
import { useModal, WorkflowContext } from "../contexts";
import useUser from "../hooks/useUser";
import ErrorModal from "./ErrorModal";
import LoadingModal from "./LoadingModal";
import OAuthModal from "./OAuthModal";

function WorkflowAiEnrichmentSettings() {
  const { t } = useTranslation();

  const { workflow, mutateWorkflow } = useContext(WorkflowContext);
  const { openModal, closeModal } = useModal();
  const { hasPermission } = useUser();
  const history = useHistory();

  const canEdit = hasPermission(workflow.team, "workflows.edit");

  async function addAiEnrichment() {
    openModal(<LoadingModal title={t("Adding new Block")} />);

    try {
      await postData(`/workflows/${workflow.id}/ai-enrichment/`);
      await mutateWorkflow();

      history.push("/w/" + workflow.id + "/ai-enrichment");
      closeModal();
    } catch (error) {
      if (error instanceof OAuthError)
        openModal(<OAuthModal oauthUrl={error.oauthUrl} />);
      else
        openModal(<ErrorModal details={error} />);
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <div className="text-xs bg-purple/10 text-gray-600 rounded-sm px-3 py-2">
          <Link to="/context-hub" className="flex items-center gap-1 text-xs font-gilroy font-semibold text-blue hover:underline w-fit">
            {t("Open Context Hub")}
            <ExternalLinkIcon className="w-3 h-3" />
          </Link>
          {t("AI Document suggestions are generated using the business knowledge in your Context Hub.")}
        </div>
        {(!workflow.aiEnrichment && canEdit) &&
          <button className="btn btn-white text-sm flex items-center justify-center gap-2 mt-2" onClick={addAiEnrichment} type="button">
            <SparklesIcon className="w-4 h-4" />
            {t("Enable AI Document Enrichment")}
          </button>
        }
      </div>
    </div>
  );
}

export default WorkflowAiEnrichmentSettings;
